"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = times;

var _optimizeCb = _interopRequireDefault(require("./_optimizeCb.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Run a function **n** times.
function times(n, iteratee, context) {
  var accum = Array(Math.max(0, n));
  iteratee = (0, _optimizeCb.default)(iteratee, context, 1);

  for (var i = 0; i < n; i++) accum[i] = iteratee(i);

  return accum;
}